import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import TitleSlide from "../../components/Slides/templates/TitleSlide";
import CodePen from "../../components/Codepen/Codepen";
import { Alert } from "react-bootstrap";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";

export default function S01P00({ reveal }: ISlideObject) {
  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Empezaremos en unos minutos"
      />
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Semana 01 Parte 1"
      />
      <DefaultSlide title="¡Bienvenid@s!">
        <div>
          <p style={{ fontSize: "3em", textAlign: "center" }}>"</p>
          <blockquote>
            Ser experto en algo consiste en saber casi mil formas de hacerlo de
            forma incorrecta <br />
            <br /> - Desconocido
          </blockquote>
        </div>
      </DefaultSlide>
      <DefaultSlide title="Agenda">
        <div>
          <ul>
            <li>Bienvenida.</li>
            <li>Presentación de l@s compañeros y docente.</li>
            <li>Programa de curso.</li>
            <li>Herramientas de trabajo.</li>
            <li>Ajustando las expectativas.</li>
          </ul>
        </div>
      </DefaultSlide>
      <section>
        <TitleSlide title="Presentación"></TitleSlide>
        <DefaultSlide title="Victor Vargas Ramírez">
          <div className="col-no-padding dp-center">
            <img src="/images/S01/me.jpg" alt="foto de victor vargas." />
          </div>
          <div className="col" style={{ fontSize: "0.5em" }}>
            <ul>
              <li>Administración de Tecnología de Información</li>
              <li>16 años en Software</li>
              <li>8 años liderando proyectos de desarrollo de software</li>
              <li>Sector público, privado y Startups.</li>
              <li>Profesor e investigador</li>
              <li>Gerente de Ingeniería - Ciberseguridad</li>
              <li>Msc Ciberseguridad en Royal Holloway University of London</li>
              <li>Actualmente Software Engineer</li>
            </ul>
          </div>
        </DefaultSlide>
        <ImageSlide title="Su turno" image="/images/S01/classroom.jpg">
          <ul>
            <li>Nombre</li>
            <li>¿De donde son?</li>
            <li>¿Qué te gustaría aprender en este curso?</li>
            <li>¿Experiencia con aplicaciones web?</li>
          </ul>
        </ImageSlide>
      </section>
      <section>
        <DefaultSlide title="Programa de curso 👨‍🏫">
          <iframe
            title="programa de curso"
            className="fullscreen"
            src="https://docs.google.com/document/d/e/2PACX-1vT57_8VxfFPw91XsgToWPObIPY-8xgHzbPZof6c-FnWSpprtE53ppRtYXgdLZwhrQ/pub?embedded=true"
          ></iframe>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="Herramientas de trabajo 🛠️" />
        <section>
          <p>
            A lo largo del curso vamos a utilizar diversas herramientas y
            tecnologías. Algunas serán contenido activo del curso, otras serán
            requerimientos
          </p>
          <p className="fragment">
            Estos requerimientos serán las primeras tareas del curso, así que si
            ya has trabajado con alguna de esas tecnologías ya vas un paso
            adelante 😎
          </p>
        </section>
        <DefaultSlide title="MS Teams">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p>
              Con tu cuenta de estudiante tienes acceso a la suite de Microsoft,
              que incluye MS Teams. Esta será nuestra herramienta oficial de
              comunicación del curso. A continuación te dejo algunos detalles de
              los chats que verás en el grupo del curso.
            </p>
            <ul>
              <li>
                <strong>General.</strong> Utilizado para realizar consultas
                administrativas del curso y comunicación general. Por ejemplo,
                notificar sobre publicación de nuevas lecciones, solicitar
                confirmación de lectura, notificar sobre algún problema con
                alguna clase.
              </li>
              <li>
                <strong>Preguntas.</strong> Ingresar acá preguntas
                exclusivamente del contenido del curso. Por ejemplo, dudas sobre
                algún tema visto en clase, preguntas sobre alguna tarea.
              </li>
              <li>
                <strong>Foros.</strong> A lo largo del curso se publicarán
                preguntas sobre temas relacionados con aplicaciones web. Debes
                responder y participar en estas discusiones.
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Editor local">
          <div className="col">
            <img src="/images/S01/vscode.png" alt="Visual studio logo" />
            <p>
              {" "}
              Para editar código en ambientes locales vamos a utilizar VS Code.
              En unos minutos hablaremos de plugins y herramientas de
              configuración, así como conocimientos previos necesarios.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Visualización de código">
          <div className="d-flex flex-column" style={{ width: "100%" }}>
            <p>
              Además utilizaremos mucho CodePen.io una herramienta para
              visualización y edición de código en línea.
            </p>
            <CodePen title="Basic HTML" penId="KwPGQNx" />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Git">
          <div className="d-flex flex-column" style={{ width: "100%" }}>
            <img
              src="/images/S01/github.png"
              alt="Github studio logo"
              width={"200px"}
              className="center"
            />
            <ul>
              <li>
                Utilizaremos GitHub como herramienta de versionamiento de
                código.
              </li>
              <li>
                Pronto utilizaremos Github Actions y más herramientas para
                desplegar aplicaciones de forma ágil.
              </li>
            </ul>
            <Alert className="fragment" variant="info">
              Conocimientos en Git son necesarios para este curso.
            </Alert>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Tarea Opcional. Aprendiendo sobre Git">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.8em" }}
          >
            <Alert variant="success">
              Objetivo: Aprender sobre git y github y de estrategias de
              ramificación.
            </Alert>
            <p>
              A continuación tienes algunos recursos valiosos que te permiten
              conocer más sobre git:
            </p>
            <ul>
              <li>
                <a href="https://www.udemy.com/course/git-started-with-github/">
                  Git Started with GitHub.
                </a>{" "}
                Curso completo de 1h
              </li>
              <li>
                <a href="https://www.coursera.org/learn/version-control-with-git">
                  Version Control with Git.
                </a>{" "}
                Para aquellos que deseen un conocimiento más profundo, curso de
                11 horas.
              </li>
              <li>
                <a href="https://learngitbranching.js.org/">
                  LearnGitBranching.
                </a>{" "}
                Un concepto muy importante en git son las ramificaciones. Este
                sitio web permite conocer más al respecto.
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <section>
          <h2>¿Tienes alguna duda?</h2>
          <p>
            Es muy posible que alguien más también la tenga, por lo que
            trabajaremos con chats que nos permitan solventar las preguntas y
            proporcionar un aprendizaje colectivo.
          </p>
          <p>
            Utiliza el canal en MS Teams llamado "Preguntas" para enviar
            cualquier consulta que tengas.
          </p>
        </section>
        <DefaultSlide title="Tarea 01. Trabajando con Git">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.8em" }}
          >
            <Alert variant="success">
              Objetivo: Demostrar conocimiento en el uso de git y github. <br />
              <span style={{ fontSize: "0.5em" }}>Vence: 26 Febrero 2025</span>
            </Alert>
            <ol>
              <li>Crea una cuenta de Github (Si aún no tienes una).</li>
              <li>
                Crea un nuevo repositorio público en github llamado
                "AplicacionesWeb". Incluye el archivo README.md y agrega una
                licencia MIT.
              </li>
              <li>
                Sigue las instrucciones del nuevo proyecto para clonarlo
                localmente en tu computadora local.
              </li>
              <li>
                Cambia el nombre de la rama principal de "master" a "main".
              </li>
            </ol>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Tarea 01. Trabajando con Git">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.75em" }}
          >
            <ol start={5}>
              <li>
                Modifica el Readme.md completando la siguiente frase: "Este es
                el curso de desarrollo ágil de aplicaciones web, en el que
                espero aprender [COMPLETAR]"
              </li>
              <li>
                Crea un commit de git sobre main y sube los cambios al
                repositorio remoto.
              </li>
              <li>
                En el canal de MS Teams llamado "Foros" encontrarás una
                conversación cuyo título empieza con "S01F01". Responde en esa
                conversación con la siguiente información:
                <ul>
                  <li>Mi nuevo repositorio es: [Link de tu repo de git]</li>
                  <li>Lo que más me gusta de git es [COMPLETAR]</li>
                  <li>
                    Desde mi perspectiva personal, lo más retador de git es
                    [COMPLETAR]
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Containers">
          <img
            src="/images/S01/docker.png"
            alt="Docker logo"
            width={"150px"}
            height={"150px"}
            className="center"
          />
          <div className="d-flex flex-column">
            <ul>
              <li>
                Utilizaremos Docker como herramienta para gestionar ambientes de
                desarrollo y crear aplicaciones aisladas e independientes del
                sistema operativo.
              </li>
              <li>
                La herramienta de gestión que utilizaremos es Docker, por su
                facilidad de uso de interfaz gráfica.
              </li>
            </ul>
            <Alert className="fragment" variant="info">
              Conocimientos en Docker son necesarios para este curso.
            </Alert>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Tarea Opcional. Aprendiendo sobre Docker">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.8em" }}
          >
            <Alert variant="success">
              Objetivo: Aprender sobre contenedores.
            </Alert>
            <p>
              A continuación tienes algunos recursos valiosos que te permiten
              conocer más sobre contenedores y docker:
            </p>
            <ul>
              <li>
                <a href="https://www.youtube.com/watch?v=GFgJkfScVNU">
                  Learn Docker in 1 Hour.
                </a>{" "}
                Curso básico de una hora.
              </li>
              <li>
                <a href="https://www.coursera.org/learn/docker-for-the-absolute-beginner">
                  Docker Hands-on Labs.
                </a>{" "}
                Para aquellos que deseen un conocimiento más profundo, curso de
                9 horas.
              </li>
              <li>
                <a href="https://docker.courselabs.co/">Docker Course Labs.</a>{" "}
                Un sitio web para aprender siguiendo pasos tipo taller. Con la
                parte 1 y 2 es suficiente para este curso.
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <section>
          <h2>¿Tienes alguna duda?</h2>
          <p>
            Recuerda utilizar el canal en MS Teams llamado "Preguntas" para
            enviar cualquier consulta que tengas.
          </p>
        </section>
        <DefaultSlide title="Tarea 02. Analizando las herramientas">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.8em" }}
          >
            <Alert variant="success">
              Objetivo: Demostrar conocimiento crítico de las herramientas del
              curso. <br />
              <span style={{ fontSize: "0.5em" }}>Vence: 26 Febrero 2025</span>
            </Alert>
            <ol>
              <li>
                En el canal de MS Teams llamado "Foros" encontrarás una
                conversación cuyo título empieza con "S01F02.". Responde en esa
                conversación con la siguiente información:
                <ul>
                  <li>
                    Hemos visto dos herramientas clave para el desarrollo de
                    este curso: Git y Contenedores. Utilizando tus propias
                    palabras y con tu conocimiento actual, ¿por qué crees que
                    estas herramientas son tan relevantes en este curso?
                  </li>
                </ul>
              </li>
            </ol>
          </div>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="Expectativas" />
        <section>
          <h2>Código de honor</h2>
          <ul>
            <li>Apertura para aprender y equivocarse.</li>
            <li>
              Copilot es una gran herramienta para apoyar en la educación.
            </li>
            <li>Participación activa.</li>
            <li>Respeto y profesionalismo.</li>
            <li>Responsabilidad.</li>
            <li>Retroalimentación activa de ambas partes.</li>
          </ul>
        </section>
        <DefaultSlide title="Expectativa">
          <div className="col2">
            <img src="/images/S01/atencion.jpg" alt="La expectativa" />
          </div>
          <div className="col2 fragment">
            <img src="/images/S01/expectativa.jpeg" alt="La no expectativa" />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Listas de difusión">
          <p>Te recomiendo suscribirte a:</p>
          <ul>
            <li><a target="_blank" rel="noreferrer" href="https://css-weekly.com/">CSS Weekly</a></li>
            <li><a target="_blank" rel="noreferrer" href="https://css-tricks.com/">CSS Tricks</a></li>
            <li><a target="_blank" rel="noreferrer" href="https://frontendfoc.us/">Frontend focus</a></li>
            <li><a target="_blank" rel="noreferrer" href="https://javascriptweekly.com/">JavaScript Weekly</a></li>
            <li><a target="_blank" rel="noreferrer" href="https://webtoolsweekly.com/">Web tools Weekly</a></li>
          </ul>
        </DefaultSlide>
      </section>
      <ImageSlide
        image="/images/S01/party-dance.gif"
        title="¡Fin de la primera parte!"
      >
        <p>
          Ya debes tener una idea de los contenidos que vamos a ver durante las
          próximas 16 semanas. Puedes cerrar esta ventana y volver a los contenidos de la semana en MS Teams
        </p>
        {/* <button className="btn btn-success">Marcar como completo</button> */}
      </ImageSlide>
    </>
  );
}
